import { MatTableDataSource } from '@angular/material/table';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgForm } from '@angular/forms';
import { LoggerService } from 'src/shared/logger/logger.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Levels } from 'src/shared/logger/levels.enum';
import { HomeService } from 'src/homepage/shared/home.service';
import { monitorProvisionObj, statusUnitObj } from 'src/homepage/shared/home.models';
import { MatDialog } from '@angular/material/dialog';
import { DialogConfirmationComponent } from 'src/shared/Dialogs/dialog-confirmation/dialog.confirmation.component';


@Component({
  templateUrl: './dialog-status.component.html',
  styleUrls: ['./dialog-status.component.css'],
  providers: [HomeService]
})
export class DialogStatusComponent implements OnInit {
  unitsToBeHandled: statusUnitObj[] = [];
  displayedColumns = ["icon", "description", "action"];
  logsTableData: MatTableDataSource<statusUnitObj> = new MatTableDataSource([]);

  pageTitle: string = "";
  message: string = "";

  constructor(
    public dialogRef: MatDialogRef<DialogStatusComponent>,
    private homeService: HomeService,
    private loggerService: LoggerService,
    private _snackBar: MatSnackBar, public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public statusReceived: string
  ) { }

  ngOnInit(): void {
    if (this.statusReceived == "In a call") {
      this.pageTitle = "In a call";
      this.homeService.getInACallUnits().subscribe(data => {
        this.adjustDataForTable(data);
      }, err => {
        this.message = "Total units retrieved are " + 0 + " units";
        this.loggerService.log("DialogStatusComponent", err.error.message ? err.error.message : "Error while sending data", Levels.error)
      })
    } else if (this.statusReceived == "No HTTPS response") {
      this.pageTitle = "No Https Response";
      this.homeService.getNoResponseUnits().subscribe(data => {
        this.adjustDataForTable(data);
      }, err => {
        this.message = "Total units retrieved are " + 0 + " units";
        this.loggerService.log("DialogStatusComponent", err.error.message ? err.error.message : "Error while sending data", Levels.error)
      })
    } else if (this.statusReceived == "Idle") {
      this.pageTitle = "Idle";
      this.homeService.getIdleUnits().subscribe(data => {
        this.adjustDataForTable(data)
      }, err => {
        this.message = "Total units retrieved are " + 0 + " units";
        this.loggerService.log("DialogStatusComponent", err.error.message ? err.error.message : "Error while sending data", Levels.error)
      })
    } else if (this.statusReceived == "Incorrect Password") {
      this.pageTitle = "Incorrect Password";
      this.homeService.getIncorrectPasswordUnits().subscribe(data => {
        this.adjustDataForTable(data)
      }, err => {
        this.message = "Total units retrieved are " + 0 + " units";
        this.loggerService.log("DialogStatusComponent", err.error.message ? err.error.message : "Error while sending data", Levels.error)
      })
    } else {
      this.pageTitle = "Relay-Unit connection error";
      this.homeService.getInRelayErrorUnits().subscribe(data => {
        this.adjustDataForTable(data)
      }, err => {
        this.message = "Total units retrieved are " + 0 + " units";
        this.loggerService.log("DialogStatusComponent", err.error.message ? err.error.message : "Error while sending data", Levels.error)
      })
    }
  }

  adjustDataForTable(data) {
    for (const key in data.data) {
      for (let i = 0; i < data.data[key].length; i++) {
        this.unitsToBeHandled.push(new statusUnitObj(data.data[key][i]["system_ip"], data.data[key][i]["system_name"], key, data.data[key][i]["status"]))
      }
    }
    this.logsTableData = new MatTableDataSource(this.unitsToBeHandled);
    this.message = "Total units retrieved are " + this.unitsToBeHandled.length + " units";
  }


  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 8000,
      panelClass: ['mat-toolbar', 'mat-primary']
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.logsTableData.filter = filterValue.trim().toLowerCase();
  }

  sendAppropriateRequest(element: monitorProvisionObj) {
    // element.processingFlag = true;
    // if (this.statusReceived == "No HTTPS response") {
    //   this.homeService.provisionUnit(element.system_ip).subscribe(data => {
    //     element.processingFlag = false;
    //     element.resultSuccessFlag = true;
    //   }, err => {
    //     this.loggerService.log("DialogMonitorProvisionComponent", err.error.message ? err.error.message : "Error while sending data", Levels.error)
    //     element.processingFlag = false;
    //     element.resultFailedFlag = true;
    //   })
    // }

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onYesClick(): void {
    this.dialogRef.close();
  }

}
